module.exports = __webpack_public_path__ + "assets/c83ef4f6ef92cedcc5163611db69650a.svg";